import * as React from "react";
import { TextField } from "@origin-digital/ods-core";
import { Field, useFormikContext } from "formik";
import { IGeneralTextField } from "../FormComponents/GeneralTextField";
import { apiClient } from "src/api/apiService";
import { PremiseDetails } from "src/components/Changes/types";
import { ChangeRequestFormValues } from "./formValue";
import { MirnStatusEnum } from "./StatusAlert";

const Mirn: React.FC = () => {
  return <Field component={MirnField} name="mirn" label="MIRN" />;
};

const MirnField = (props: IGeneralTextField) => {
  const { field, label, id, type, startIcon, helperText, maxLength, disabled } =
    props;

  const { errors } = useFormikContext<ChangeRequestFormValues>();
  const formikError = errors.mirn;
  const { value, onChange } = field;
  const [error, setError] = React.useState<string>();
  const {
    setFieldValue,
    values: { mirnStatus },
  } = useFormikContext<ChangeRequestFormValues>();
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    const validateMirn = async () => {
      if (value && value.length === 10) {
        setIsLoading(true);
        try {
          const response = await apiClient.get<{
            mirn_status: string;
            premise: PremiseDetails;
          }>(`/mirn/status/${value}`);
          const { mirn_status, premise } = response.data;
          setFieldValue("mirnStatus", mirn_status);
          setFieldValue("premise", premise);
          if (mirn_status === MirnStatusEnum.NOT_FOUND) {
            setError("MIRN not found");
          } else {
            setError(undefined);
          }
        } catch (err) {
          setError("Error validating MIRN");
        } finally {
          setIsLoading(false);
        }
      }
    };

    validateMirn();
  }, [value]);

  const getEndIcon = () => {
    if (isLoading) {
      return "validating";
    }
    if (mirnStatus === null) {
      return undefined;
    }
    if (error || mirnStatus === MirnStatusEnum.NOT_FOUND) {
      return "error";
    }
    if (mirnStatus === MirnStatusEnum.ELIGIBLE) {
      return "success";
    }
    return undefined;
  };

  return (
    <TextField
      {...field}
      onChange={(e) => {
        const numericValue = e.target.value.replace(/[^0-9]/g, "");
        if (numericValue.length <= 10) {
          e.target.value = numericValue;
          onChange(e);
        }
      }}
      id={id}
      variant="outlined"
      label={label}
      error={!!formikError || !!error}
      helperText={formikError || error || helperText}
      hideHelperTextSpace
      type={type}
      startIcon={startIcon}
      maxLength={maxLength}
      endIcon={getEndIcon()}
      disabled={disabled}
    />
  );
};

export default Mirn;
